import { AppSettings } from "@/AppSettings";
import useItem from "@/hooks/form/source-data/useItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import { Box, Tooltip, TooltipProps, styled } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { ButtonPlaceholder, CounterButton, CounterButtonBox, StyledTooltip } from ".";
import useForm from "@/hooks/form/source-data/useForm";
import { SourceDataFormStatus } from "@/api/dtos";



const SourceDataFormNoteButton: FC<{ 
    form: ReturnType<typeof useForm>;
    itemData?: ReturnType<typeof useItem>; 
    createButtonProps: (link: string) => any 
}> = ({
    form,
    itemData,
    createButtonProps
}) => {
    if (!itemData) {
        return <ButtonPlaceholder />;
    }

    const disabled = !form?.sourceDataForm || form.sourceDataForm.status === SourceDataFormStatus.None || form.sourceDataForm.status === SourceDataFormStatus.Skipped; //false; //!itemData.sourceDataItem;

    let buttonProps: any = createButtonProps(itemData?.preview ? itemData.previewAuditLink : itemData?.dataAuditLink!);

    return (
        <Box>
            <StyledTooltip
                title={
                    disabled ? 
                        'Form does not exist in OpenClinica' :
                        'Audit'
                }
                followCursor
            >
                <CounterButtonBox>
                    <CounterButton
                        variant="outlined"
                        //@ts-ignore
                        {...buttonProps}
                        disabled={disabled}
                    >
                        <FontAwesomeIcon icon={AppSettings.icons.audit} size="2x" />
                    </CounterButton>
                </CounterButtonBox>
            </StyledTooltip>
        </Box>
    );
};

export default SourceDataFormNoteButton;